import React, { useState } from 'react';
import classNames from "classnames";
import { useWeb3React } from "@web3-react/core";

// Hook
const useLocalStorage = (key, defaultValue) => {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => {
      if (typeof window === "undefined") {
        return defaultValue;
      }

      try {
        const item = window.localStorage.getItem(key);
        return item != null ? item : defaultValue;
      } catch (error) {
        console.log(error);
        return defaultValue;
      }
    });

    const setValue = (value) => {
      try {
        // Allow value to be a function so we have same API as useState
        const valueToStore =
          value instanceof Function ? value(storedValue) : value;
        // Save state
        setStoredValue(valueToStore);
        // Save to local storage
        if (typeof window !== "undefined") {
          window.localStorage.setItem(key, JSON.stringify(valueToStore));
        }
      } catch (error) {
        console.log(error);
      }
    };
    return [storedValue, setValue];
  }

const Rewards = () => {

    const [tokens, setTokens] = useLocalStorage("tokens", 100);
    const [isRewardRevealed, setIsRewardRevealed] = useState(false);

    const {
        library,
        chainId,
        account,
        activate,
        deactivate,
        active
    } = useWeb3React();

    const RewardItem = (props) => {
        return (
            <li className="reward-item">
                <div>
                    <figure>
                        <img src={require("../assets/images/hidden.png")} width={300} height={300} alt="NFT Preview"/>
                    </figure>
                    <div>
                    </div>
                    <div>
                        <p>{props.name}</p>
                        <button className="button button-primary button-wide-mobile button-sm" onClick={subtractTokens}>Redeem</button>
                    </div>
                </div>
            </li>
        );
    }

    const RevealedReward = (props) => {
        return (
            <li className="revealed-item">
                <div>{props.revealMsg}</div>
            </li>
        )
    }

    const subtractTokens = () => {
        if(tokens - 10 < 0){
            alert("Insufficient tokens!");
        }
        else{
            setTokens(tokens - 10);
            setIsRewardRevealed(true);
        } 
    }

    return(
        <section className={classNames("section", "center-content", "rewards-section")}>
            <div className="container-sm">
                <div className="rewards-container">
                    <h1>Rewards</h1>
                    {active ? (
                        <div className="rewards-row">
                            <p>You have {tokens} tokens</p>
                            <ul>
                                {isRewardRevealed ? (
                                    <RevealedReward revealMsg="You have just won A Bored Ape NFT!!!!!"/>
                                ) : (
                                    <RewardItem name="Mystery Box"/>
                                )}
                            </ul>
                        </div>
                    ): (
                        <p>You must be connected to claim rewards</p>
                    )}
                </div>
                    
            </div>
        </section>
    );
}

export default Rewards;